import React from 'react';
import {RANKING_FILES} from  '../../config';
export const DownloadModal = ({ setIsModalOpen, slug }) => ({
	title: 'Download "Global passport index ranking" file?',
	FooterComponent: () => {
		const fileLink = RANKING_FILES[slug];
		
		return (
			<a
				href={fileLink}
				target="_blank"
				className="modal__btn btn btn__secondary"
				aria-label="Close this dialog window"
				onClick={() => {
					setIsModalOpen(false);
				}}
			>
				Download as PDF
			</a>
		);
	},
});
